// Valid :subpage values for the /connections/:connection_id/:subpage(/...) routes.
// Shared by the connection details tabs and by route-level 404 validation in
// every component mounted under a :subpage route — keep in sync with the tabs.
export const CONNECTION_SUBPAGES = ["overview", "provider", "destinations", "sources", "logs", "webhook"] as const;

// An absent subpage is valid (it defaults to "overview" / doesn't apply).
export const isValidConnectionSubpage = (subpage?: string): boolean =>
    !subpage || CONNECTION_SUBPAGES.includes(subpage as typeof CONNECTION_SUBPAGES[number]);
